/**
 * Created by commyfeng on 2017/3/27.
 */
import filterResponse from "./filterResponse";
export default function (Coa) {
  Coa.filterResponse = filterResponse;
}